<template>
  <el-dialog append-to-body :title="title" :visible.sync="dialogFormVisible" @open="handleDialogOpen" width="40%">
    <div>
      <span>想要通过excel批量{{title}}数据，请按以下步骤依次执行：</span>
    </div>
    <div style="margin-top: 17px">
      <span>步骤1：点击&nbsp;</span>
      <a :href="href" :download="download">这里</a>
      <span>&nbsp;下载excel模板。</span>
    </div>
    <div style="margin-top: 17px">
      <span>步骤2：按照模板要求填写数据。</span>
    </div>
    <div style="margin-top: 17px">
      <span>步骤3：选取并导入模板文件</span>
      <el-upload
        class="upload-demo"
        action="/apps/res/uploadFile"
        name="file"
        :headers="uploadHeaders"
        :data="uploadParams"
        :on-error="handleError"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :file-list="fileList">
        <el-button :loading="importloading" size="small" type="primary">导入文件</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xlsx文件，且不超过200MB</div>
      </el-upload>
    </div>
    <div style="color:#F56C6C;margin-top:10px">
      <div style="color:#F56C6C;">注意事项：</div>
      <div style="margin-top:3px;font-size:12px;">1. 每个字段的汉字名称不要修改，系统需要根据这些字段名字来对应</div>
      <div style="font-size:12px;">2. 不要修改模板中有约束值的约束，比如下拉选项，只能填数字等</div>
      <div style="font-size:12px;">3. 不要留有空行</div>
      <div style="font-size:12px;">4. 如果需要增加下拉选项，请先联系管理员</div>
      <div style="font-size:12px;">5. 第一次导入成功后，再次导入将在原有内容上“追加”</div>
      <div style="font-size:12px;">6. 导入表格中每行每列段前去掉序号（序号系统会自动产生，否则会和表格内序号叠加显示）</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="hideDlg" size="mini">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import * as types from '@/vuex/types'
  export default {
    props: {
      title: String,
      href: String,
      url: String,
      download: String,
      unitId: Number,
      params: Object,
      prompt: String,
    },
    data () {
      return {
        dialogFormVisible: false,
        fileList: [],
        uploadHeaders: {
          sid: this.$store.state.sessionId
        },
        uploadParams: {
          dir: 'file',
          role: 4
        },
        importloading: false
      }
    },
    methods: {
      // 显示表单对话框
      showImportUserDlg () {
        this.dialogFormVisible = true
      },
      // 隐藏对话框
      hideDlg () {
        this.dialogFormVisible = false
      },
      // 打开对话框的事件响应
      handleDialogOpen () {
        this.fileList = []
      },
      handleError (err) {
        console.log(err)
        this.$alert('导入超时：' + response.data.msg, '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
      },
      handleSuccess (res, file, fileList) {
        this.fileList = []
        if (res.code === 0) {
          this.importloading = true
          this.$http.post(this.url, {
            file: res.data['url'],
            unit_id: this.unitId ? this.unitId : null,
            ...this.params
          }).then(response => {
            this.importloading = false
            if (response.data.code === 0) {
              // 如果成功
              this.$alert(this.prompt ? this.prompt : '导入成功！', '提示', {
                confirmButtonText: '确定',
                dangerouslyUseHTMLString: true,
                callback: action => {
                  // 关闭对话框
                  this.dialogFormVisible = false
                  // 触发刷新表格事件
                  this.$emit('refreshTable')
                }
              })
            } else {
              // 如果失败
              this.$alert('导入失败！原因：' + response.data.msg, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              })
            }
          }).catch(error => {
            this.$alert('导入失败！已超时：' + response.data.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
            console.log(error)
          })
        } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
          this.$store.commit(types.LOGOUT)
          this.$router.replace({ name: 'login' })
        } else {
          this.$alert('文件上传失败！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
        }
      },
      beforeUpload (file) {
        console.log(file,"文件信息！")
        const isXLSX = (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel' || file.type === 'application/wps-office.xlsx')
        const isLt5M = file.size / 1024 / 1024 < 200
        if (!isXLSX) {
          this.$message.error('上传文件只能是 XLSX 格式!')
        }
        if (!isLt5M) {
          this.$message.error('上传文件大小不能超过 200MB!')
        }
        return isXLSX && isLt5M
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/Util/ImportUserFDlg.vue